import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormBuilder, RenderConfig, Row } from 'commons-ui';
import { EMPTY_STRING, EBooleanStatus } from 'commons-ui/src/constants';
import { Button } from 'baseui/button';
import { CsvUploadPreview } from '../../../../components/upload';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../helper';
import { validationSchema } from '../utils/validationSchema';
import { parseCsv } from '../utils/csvUtils';
import { TABLE_COLUMNS, FORM_FIELD_KEYS, PLACEHOLDERS } from '../constants';
import useService from '../utils/useService';

const CreateRequest: React.FC = () => {
	const service = useService();
	const history = useHistory();
	const [showLoader, setShowLoader] = React.useState(false);
	const [csvRows, setCsvRows] = React.useState<any[]>([]);

	const sampleHeaders =
		'Email ID,Action,Username,Phone No,Department,Manager,Designation,Team,Role Name,Permissions,Permission Set,Expire After Sec,Is Masked\n';

	const downloadSample = () => {
		const blob = new Blob([sampleHeaders], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'sample_bulk_user.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const csvField = new RenderConfig()
		.setName('csvFile')
		.setLabel('CSV File')
		.setRenderer(CsvUploadPreview)
		.setRenderProps({
			isEditable: { create: true },
			isHidden: { create: false },
			required: true,
			accept: '.csv',
			placeholder: PLACEHOLDERS.CSV_FILE,
			parseCsv,
			columns: TABLE_COLUMNS.CSV_PREVIEW,
			rowFormatter: (row: any, idx: number) => [
				idx + 1,
				row.email ?? EMPTY_STRING,
				row.action ?? EMPTY_STRING,
				row.username ?? EMPTY_STRING,
				row.phone ?? EMPTY_STRING,
				row.department ?? EMPTY_STRING,
				row.manager ?? EMPTY_STRING,
				row.designation ?? EMPTY_STRING,
				row.team ?? EMPTY_STRING,
				row.roleName ?? EMPTY_STRING,
				row.permissions ? JSON.stringify(row.permissions) : EMPTY_STRING,
				row.permissionSet ?? EMPTY_STRING,
				row.expireAfter ?? EMPTY_STRING,
				row.isMasked === undefined ? EMPTY_STRING : row.isMasked ? EBooleanStatus.YES : EBooleanStatus.NO
			],
			onValidRows: (rows: any[]) => {
				setCsvRows(rows);
			}
		});

	const fieldConfig = {
		...FORM_FIELD_CONFIG,
		[FORM_FIELD_KEYS.CSV_FILE]: csvField
	};

	const layoutConfig = [...FORM_LAYOUT_CONFIG, new Row(FORM_FIELD_KEYS.CSV_FILE)];

	return (
		<>
			<Button kind='secondary' size='compact' onClick={downloadSample} style={{ marginBottom: '8px' }}>
				Download Sample CSV
			</Button>
			<FormBuilder
				data={{ description: '', csvFile: null }}
				mode='create'
				showLoader={showLoader}
				validationSchema={validationSchema}
				handleFormSubmit={async (formData: { description: string }) => {
					await service.createRequest({ description: formData.description, data: csvRows });
					const listPath = history.location.pathname.replace(/\/create$/, '/list');
					history.push(listPath);
				}}
				handleFormCancel={() => window.history.back()}
				setShowLoader={setShowLoader}
				fieldConfig={fieldConfig}
				layoutConfig={layoutConfig}
			/>
		</>
	);
};

export default CreateRequest;
